import { FC } from 'react'
import { isNil } from 'lodash'

import { Avatar, chain, Ellipsis, HStack, Item, Text } from '@revolut-internal/ui-kit'

import { useChannel } from 'hooks/useChannel'
import { Ticket } from 'types'
import { formatDuration, getFormattedDateTime } from 'utils/formatTimeAndDuration'

type ResourcesPanelTicketProps = {
  ticket: Ticket
}

export const ResourcesPanelTicket: FC<ResourcesPanelTicketProps> = ({ ticket }) => {
  const { isDante } = useChannel()

  return (
    <Item use="a" target="_blank" href={ticket.uri}>
      <Item.Avatar>
        <Avatar useIcon={isDante ? 'NationalId' : 'Chat'} />
      </Item.Avatar>
      <Item.Content>
        <Item.Title>{getFormattedDateTime(ticket.createdDate)}</Item.Title>
        <Item.Description>
          <HStack align="center">
            {chain(
              !isNil(ticket.qwt) && (
                <Text style={{ flexShrink: 0 }}>{formatDuration(ticket.qwt)}</Text>
              ),
              <Ellipsis tooltip="always">{ticket.queue.name}</Ellipsis>,
            )}
          </HStack>
        </Item.Description>
      </Item.Content>
    </Item>
  )
}
